//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaiduMapTrack from "@/0/components/comMap/comShowBaiduMapTrack.vue";
export default {
  components: {
    "baidu-map-track": BaiduMapTrack
  },
  props: ["controlItem"],
  data() {
    return {

    };
  },
  computed: {
    cellClass: function() {
      return {
        "van-cell": true,
        "van-field": true,
        "van-cell--required": this.controlItem.IsRequired
      };
    }
  },
  created() {    
    
  },

  mounted() {
    var controlValue = this.controlItem.ControlValue;
    if(!controlValue) return;

    this.$refs.comMapTrack.setControlValue(controlValue);
  },

  methods: {
    
  }
};
